import axios from "axios";
/**
 * 1. Device ID Management
 */
const getDeviceId = () => {
  try {
    const todayKey = new Date().toDateString();
    const storedDate = localStorage.getItem("device_id_date");
    let deviceId = localStorage.getItem("device_id");

    if (!deviceId || storedDate !== todayKey) {
      deviceId = window.crypto?.randomUUID
        ? window.crypto.randomUUID()
        : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
      localStorage.setItem("device_id", deviceId);
      localStorage.setItem("device_id_date", todayKey);
    }
    return deviceId;
  } catch (e) {
    return null;
  }
};

const instance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

/* ================= REQUEST ================= */
instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    const deviceId = getDeviceId();

    if (token) config.headers.Authorization = `Bearer ${token}`;
    if (deviceId) config.headers["x-device-id"] = deviceId;

    return config;
  },
  (error) => Promise.reject(error)
);

/* ================= RESPONSE ================= */
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    const { response, config } = error;
    const isLoginRequest = config?.url?.includes("/login");
    const data = response?.data;

    if (response?.status === 401 && !isLoginRequest) {
      const code = data?.code;

      // Backend-driven logout
      if (code === "SESSION_EXPIRED" || code === "TOKEN_MISSING") {
        localStorage.removeItem("token");
        localStorage.removeItem("role");
        window.location.href = "/";
      }
    }
    return Promise.reject(error);
  }
);

/* ================= API HELPERS ================= */
const handleResponse = (promise) =>
  promise.then((res) => res).catch((err) => err.response);

export const getMethodApiCall = (path, params = {}, config = {}) =>
  handleResponse(
    instance.get(path, {
      params,
      ...config,
    })
  );

export const postMethodApiCall = (path, data = {}, headers = {}) =>
  handleResponse(instance.post(path, data, { headers }));

export const putMethodApiCall = (path, data = {}, headers = {}) =>
  handleResponse(instance.put(path, data, { headers }));

export const patchMethodApiCall = (path, data = {}, headers = {}) =>
  handleResponse(instance.patch(path, data, { headers }));

export const deleteMethodApiCall = (path, data = {}) =>
  handleResponse(instance.delete(path, { data }));

// --- 6. API Endpoints ---
export const fetchSummaryCardData = () =>
  getMethodApiCall("/v1/api/admin/dashboard/summary-card");
export const fetchGenderPercentage = (params) =>
  getMethodApiCall("/v1/api/admin/dashboard/gender-percentage", params);
export const fetchAttendanceByMonth = () =>
  getMethodApiCall("/v1/api/admin/dashboard/attendance-by-month");
export const fetchStudentsPerDistrict = (params) =>
  getMethodApiCall("/v1/api/admin/dashboard/students-per-district", params);

export default instance;